import styled from "styled-components";

export const VolumeCrossSC = styled.div`
  grid-column-gap: 0.4em;
  grid-row-gap: 0.4em;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const TextSC = styled.div`
  font-size: 0.8em;
  line-height: 1.2em;
`;
